export default __webpack_public_path__ + "static/media/4.b3520c53.svg";